import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import Navbar from '../components/Layout/Navbar';
import Footerpage from '../components/Layout/Footer';
import { projectData } from '../components/Sections/StudentProjects';

const DETAIL_ITEMS = [
  { key: 'role', label: 'Role', icon: 'mdi:account-hard-hat-outline' },
  { key: 'duration', label: 'Duration', icon: 'mdi:calendar-clock-outline' },
  { key: 'teamSize', label: 'Team Size', icon: 'mdi:account-group-outline' },
];

const ProjectDetails = () => {
  const { id } = useParams();
  const project = projectData.find((p) => String(p.id) === id && p.type !== 'more');

  if (!project) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="project-details-page" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />

      <div className="mx-auto max-w-4xl px-5 pb-20 pt-28 sm:pt-32">
        <Link
          to="/internship"
          className="mb-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-800"
        >
          <Icon icon="mdi:arrow-left" className="h-4 w-4" />
          Back to Live Projects
        </Link>

        <div className="overflow-hidden rounded-3xl border border-slate-200 shadow-sm">
          <img src={project.image} alt={project.title} className="h-64 w-full object-cover sm:h-96" />
        </div>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-wide text-emerald-600">{project.subtitle}</p>
          <h1 className="mt-1 text-3xl font-extrabold text-slate-900 sm:text-4xl">{project.title}</h1>

          <div className="mt-4 flex flex-wrap gap-2">
            {project.tech.map((item) => (
              <span
                key={item}
                className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700"
              >
                {item}
              </span>
            ))}
          </div>

          <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-slate-600">{project.description}</p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {DETAIL_ITEMS.map((d) => (
              <div key={d.key} className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
                <div className="flex items-center gap-2 text-slate-500">
                  <Icon icon={d.icon} className="h-4 w-4" />
                  <span className="text-xs font-semibold uppercase tracking-wide">{d.label}</span>
                </div>
                <p className="mt-1.5 text-sm font-bold text-slate-900">{project[d.key]}</p>
              </div>
            ))}
          </div>

          {project.outcome && (
            <div className="mt-6 flex items-start gap-3 rounded-2xl bg-emerald-50 p-5">
              <Icon icon="mdi:trophy-outline" className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
              <div>
                <p className="text-sm font-bold text-slate-900">Outcome</p>
                <p className="mt-1 text-sm leading-relaxed text-slate-600">{project.outcome}</p>
              </div>
            </div>
          )}

          <div className="mt-10 flex flex-col items-start justify-between gap-5 rounded-3xl bg-blue-50 p-6 sm:flex-row sm:items-center sm:p-8">
            <div>
              <h3 className="text-lg font-bold text-slate-900">Want to build something like this?</h3>
              <p className="mt-1 text-sm text-slate-600">
                Join a WeIntern program and work on real client projects with mentor support.
              </p>
            </div>
            <Link
              to="/internship"
              className="inline-flex shrink-0 items-center gap-2 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700"
            >
              Explore Live Projects
              <Icon icon="mdi:arrow-right" className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>

      <Footerpage />
    </div>
  );
};

export default ProjectDetails;
